export default __webpack_public_path__ + "static/hero-koi-computers-1-f20a109fcc9edbb69c48ca0dd064bc89.png";